/**
 * Verifications RTK Query tag-type registry (financialClearance module).
 *
 * Mirrors the agents-module pattern (`modules/agents/data/tags.ts`): all tag types are declared
 * up-front here and passed to the single base `createApi` (see `verificationsApi.ts`).
 * `injectEndpoints` cannot introduce new tag types, so any tag a feature endpoint provides or
 * invalidates MUST be listed here. Centralizing the registry is what lets a mutation in one feature
 * invalidate a query in another — that cross-feature cache invalidation only works because every
 * feature shares this one tag space.
 */
export const VERIFICATION_TAG_TYPES = [
  'Worklist',
  'WorklistTypes',
  'DashboardCounts',
  'AgentDashboardWorklist',
  'Verification',
  'VerificationDocument',
  'PreQuote',
  'PreQuoteList',
] as const;

export type VerificationTagType = (typeof VERIFICATION_TAG_TYPES)[number];
